import {combineReducers} from 'redux';
import user from './services/user/reducer';
import company from './services/company/reducer';
import notification from './services/notification/reducer';
import chat from './services/chat/reducer';
import soundWarning from './services/notification/soundWarning';

const appReducer = combineReducers({
    user,
    company,
    notification,
    chat,
    soundWarning,
});

const rootReducer = (state, action) => {
    return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducer.js